module.exports = __webpack_public_path__ + "img/logo_don_notario.e1534257.svg";